/**
 * @file   src\mobile\components\MobileDropdownSelect.js
 * @brief  This file is responsible for dropdown component in mobile
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Select, { components } from "react-select";
import CaratIcon from "../../images/carat-icon-new.svg";

const MobileDropdownSelect = (props) => {
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={CaratIcon} />
      </components.DropdownIndicator>
    );
  };

  const {
    id,
    name,
    options,
    className,
    classNamePrefix,
    placeholder,
    defaultValue,
    value,
    onChange,
    styles,
    stylesNew,
    errorMessage,
    onFocus,
    inputValue,
    errorClass,
    onInputChange,
    selectRef,
    dropDownIndicatorStatus = true,
    disabled,
    hideMenuPortal,
    isSearchable,
    pattern,
    inputmode,
    onMouseDown,
    menuPlacement
  } = props;

  return (
    <>
      <Select
        menuPortalTarget={hideMenuPortal ? "" : document.body}
        stylesNew={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        inputValue={inputValue}
        onInputChange={onInputChange}
        disabled={disabled}
        ref={selectRef}
        id={id}
        onMouseDown={onMouseDown}
        name={name}
        options={options}
        isSearchable={isSearchable}
        className={className}
        classNamePrefix={classNamePrefix}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        pattern={pattern}
        onMenuOpen={onMouseDown}
        inputMode={inputmode}
        onFocus={onFocus}
        onChange={onChange}
        styles={styles}
        isDisabled={props.disabled}
        components={
          dropDownIndicatorStatus
            ? { DropdownIndicator }
            : { DropdownIndicator: () => null, IndicatorSeparator: () => null }
        }
        menuPlacement={menuPlacement}
        menuPosition="fixed"
      />
      <span className={errorClass || "error-msg error-msg-height"}>
        {errorMessage}
      </span>
    </>
  );
};

export default MobileDropdownSelect;
